export default __webpack_public_path__ + "static/media/1095.664788ad.png";